import React from "react"

import { MainLayout } from "../layouts/main.layout"
import StandardPageHeader from "../components/layout-components/top/headers/standard-page-header/StandardPageHeader.component"
import PageSection from "../layouts/PageSection/PageSection.component"
import Footer from "../components/layout-components/bottom/footer/Footer.component"
import { getStaticImgUrl } from "../utils/getStaticImgUrl"
import { getCanonicalUrl } from "../utils/getCanonicalUrl"

const meta = {
  title: "Page not found",
  description: "Page you were looking for couldn't be found."
}

const pageSlug = "404";

export default () => (

  <MainLayout meta={meta} canonicalUrl={getCanonicalUrl(pageSlug)}>
    


    {/* 
    
          Header

    */}

    <StandardPageHeader 
      data={
        {
          heading: "Page not found",
          backgroundImage: "/unsplash-photo-1486312338219-ce68d2c6f44d-d.jpeg"
        }
      } 
    />


    
    {/* 
    
          404 page

    */}

    <PageSection>

      {/* <h>Page not found.</p> */}

    </PageSection>



    {/* 

          Footer
    
    */}

    <Footer />

  </MainLayout>
      
)